/* ============================================================
   Shop The Look — assets/stl-dialog.js
   Broadcast Theme — v4
   Ounass mobil: buton galeri içinde absolute, ikon-only
   ============================================================ */

(function () {
  'use strict';

  const dialog    = document.getElementById('stl-dialog');
  const openBtn   = document.getElementById('stl-open-btn');
  const closeBtn  = document.getElementById('stl-close-btn');
  const overlay   = document.getElementById('stl-overlay');
  const addAllBtn = document.getElementById('stl-add-all-btn');

  if (!dialog) return;

  // ============================================================
  // MOBİL: Trigger butonunu galeri container'ına taşı
  // Ounass'ta PDPMobile-imageGalleryContainer içinde konumlanıyor
  // ============================================================
  // ============================================================
  // MOBİL: Buton galeri container'ına absolute olarak yerleşir
  // Galeri bulunamazsa fallback: fixed konumlama
  // ============================================================
  function injectTriggerIntoGallery() {
    if (window.innerWidth > 768) return;

    const wrapper = document.getElementById('stl-trigger-wrapper');
    if (!wrapper) return;

    // Her durumda mobil sınıfını ekle
    wrapper.classList.add('stl-trigger-wrapper--in-gallery');

    const slideshowSelectors = [
      '.product__slideshow',
      '.flickity-viewport',
      '.product__media-gallery',
      '[data-product-slideshow]',
      '.product-single__photos',
    ];

    const outerSelectors = [
      '.product__media-wrapper',
      '.product-single__media-wrapper',
      '[data-product-media-wrapper]',
      '.product-media-wrapper',
      '.product__media',
      '.product__images',
    ];

    let container = null;

    for (const sel of slideshowSelectors) {
      const el = document.querySelector(sel);
      if (el && el.parentElement) { container = el.parentElement; break; }
    }

    if (!container) {
      for (const sel of outerSelectors) {
        container = document.querySelector(sel);
        if (container) break;
      }
    }

    if (container) {
      // Galeri bulundu: absolute olarak içine taşı
      container.classList.add('stl-gallery-host');
      container.appendChild(wrapper);
    } else {
      // Galeri bulunamadı: fixed fallback
      wrapper.classList.add('stl-trigger-wrapper--fixed');
      document.body.appendChild(wrapper);
    }

    // 3 saniye sonra metin kapanır → sadece yuvarlak ikon
    setTimeout(() => {
      wrapper.classList.add('is-collapsed');
      // Garantili gizleme
      const text = wrapper.querySelector('.stl-trigger-text');
      if (text) text.style.display = 'none';
    }, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setHeaderHeight();
      injectTriggerIntoGallery();
    });
  } else {
    setHeaderHeight();
    injectTriggerIntoGallery();
  }

  // Site header yüksekliğini ölç → CSS variable olarak set et
  function setHeaderHeight() {
    const headerSelectors = [
      'header.header',
      '.site-header',
      '#shopify-section-header',
      '[data-section-type="header"]',
      'header[role="banner"]',
      '.header-wrapper',
      'header',
    ];

    let headerEl = null;
    for (const sel of headerSelectors) {
      headerEl = document.querySelector(sel);
      if (headerEl) break;
    }

    const height = headerEl ? headerEl.offsetHeight : 60;
    document.documentElement.style.setProperty('--header-height', height + 'px');
  }

  // ============================================================
  // SCROLL LOCK
  // ============================================================
  let scrollY = 0;

  function lockScroll() {
    scrollY = window.scrollY;
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top      = `-${scrollY}px`;
    document.body.style.width    = '100%';
  }

  function unlockScroll() {
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top      = '';
    document.body.style.width    = '';
    window.scrollTo(0, scrollY);
  }

  // ============================================================
  // DIALOG AÇMA / KAPAMA
  // ============================================================
  function openDialog() {
    dialog.setAttribute('aria-hidden', 'false');
    lockScroll();
    requestAnimationFrame(() => closeBtn && closeBtn.focus());
  }

  function closeDialog() {
    dialog.setAttribute('aria-hidden', 'true');
    unlockScroll();
    openBtn && openBtn.focus();
  }

  openBtn  && openBtn.addEventListener('click', openDialog);
  closeBtn && closeBtn.addEventListener('click', closeDialog);
  overlay  && overlay.addEventListener('click', closeDialog);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && dialog.getAttribute('aria-hidden') === 'false') {
      closeDialog();
    }
  });

  // ============================================================
  // SEPET SAYACI GÜNCELLE
  // ============================================================
  function updateCartCount(itemCount) {
    if (typeof itemCount !== 'number') return;

    document.querySelectorAll('cart-count').forEach((el) => {
      el.textContent       = itemCount;
      el.dataset.cartCount = itemCount;
    });

    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      if (el.tagName.toLowerCase() === 'cart-count') return;
      el.textContent       = itemCount;
      el.dataset.cartCount = itemCount;
    });
  }

  // ============================================================
  // CART DRAWER İÇERİĞİ GÜNCELLE (Sections API)
  // ============================================================
  async function refreshCartDrawer() {
    try {
      const res = await fetch('/?sections=cart-drawer');
      if (!res.ok) return;

      const data = await res.json();
      if (!data['cart-drawer']) return;

      const parser = new DOMParser();
      const doc    = parser.parseFromString(data['cart-drawer'], 'text/html');

      const newItems = doc.querySelector('[data-items-holder]');
      const curItems = document.querySelector('[data-items-holder]');
      if (newItems && curItems) curItems.innerHTML = newItems.innerHTML;

      const newPrice = doc.querySelector('[data-cart-price-holder]');
      const curPrice = document.querySelector('[data-cart-price-holder]');
      if (newPrice && curPrice) curPrice.innerHTML = newPrice.innerHTML;

      const cartDrawerEl = document.getElementById('cart-drawer');
      if (cartDrawerEl) cartDrawerEl.classList.remove('is-empty');

    } catch (_) {}
  }

  // ============================================================
  // BEDEN SEÇİCİ
  // ============================================================
  dialog.addEventListener('change', (e) => {
    const select = e.target.closest('.stl-card__size-select');
    if (!select) return;

    const card      = select.closest('.stl-card');
    const addBtn    = card.querySelector('.stl-card__add-btn');
    const variantId = select.value;
    const selected  = select.options[select.selectedIndex];
    const avail     = selected?.dataset.available === 'true';

    if (variantId && avail) {
      addBtn.dataset.variantId = variantId;
      addBtn.disabled          = false;
      addBtn.querySelector('.stl-btn-text').textContent = 'Sepete Ekle';
      addBtn.classList.remove('is-error', 'is-success');
    } else if (variantId && !avail) {
      addBtn.disabled = true;
      addBtn.querySelector('.stl-btn-text').textContent = 'Tükendi';
    } else {
      addBtn.disabled = true;
      addBtn.querySelector('.stl-btn-text').textContent = 'Beden Seçin';
    }
  });

  // ============================================================
  // TEK ÜRÜN — SEPETE EKLE
  // ============================================================
  dialog.addEventListener('click', async (e) => {
    const btn = e.target.closest('.stl-card__add-btn');
    if (!btn || btn.disabled) return;

    const card   = btn.closest('.stl-card');
    const select = card.querySelector('.stl-card__size-select');

    if (select && !select.value) {
      select.style.borderColor = '#c0392b';
      select.focus();
      setTimeout(() => { select.style.borderColor = ''; }, 1500);
      return;
    }

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    await addToCart([{ id: variantId, quantity: 1 }], btn);
  });

  // ============================================================
  // TÜM ÜRÜNLER — SEPETE EKLE
  // ============================================================
  addAllBtn && addAllBtn.addEventListener('click', async () => {
    const items  = [];
    let hasError = false;

    dialog.querySelectorAll('.stl-card').forEach((card) => {
      const select      = card.querySelector('.stl-card__size-select');
      const hiddenInput = card.querySelector('.stl-variant-input');
      const addBtn      = card.querySelector('.stl-card__add-btn');

      if (select) {
        if (!select.value) {
          select.style.borderColor = '#c0392b';
          setTimeout(() => { select.style.borderColor = ''; }, 1500);
          hasError = true;
          return;
        }
        const sel = select.options[select.selectedIndex];
        if (sel?.dataset.available === 'true') {
          items.push({ id: select.value, quantity: 1 });
        }
      } else if (hiddenInput && hiddenInput.dataset.available === 'true') {
        items.push({ id: hiddenInput.value, quantity: 1 });
      } else if (addBtn && !addBtn.disabled) {
        items.push({ id: addBtn.dataset.variantId, quantity: 1 });
      }
    });

    if (hasError || items.length === 0) return;

    addAllBtn.disabled    = true;
    addAllBtn.textContent = 'Ekleniyor...';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });

      if (res.ok) {
        addAllBtn.textContent = 'Eklendi ✓';
        const cart = await fetch('/cart.js').then((r) => r.json());
        updateCartCount(cart.item_count);
        await refreshCartDrawer();

        // Başarılı ekleme → 800ms sonra popup kapanır
        setTimeout(() => closeDialog(), 800);
      } else {
        addAllBtn.textContent = 'Hata — tekrar dene';
        addAllBtn.disabled    = false;
      }
    } catch {
      addAllBtn.textContent = 'Hata — tekrar dene';
      addAllBtn.disabled    = false;
    }
  });

  // ============================================================
  // YARDIMCI: addToCart
  // ============================================================
  async function addToCart(items, btn) {
    const textEl   = btn.querySelector('.stl-btn-text');
    const original = textEl.textContent;

    btn.classList.add('is-loading');
    btn.disabled       = true;
    textEl.textContent = 'Ekleniyor...';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });

      if (res.ok) {
        btn.classList.remove('is-loading');
        btn.classList.add('is-success');
        textEl.textContent = 'Eklendi ✓';

        const cart = await fetch('/cart.js').then((r) => r.json());
        updateCartCount(cart.item_count);
        await refreshCartDrawer();

        // Başarılı ekleme → 800ms sonra popup kapanır
        setTimeout(() => closeDialog(), 800);

        return true;

      } else {
        const data = await res.json().catch(() => ({}));
        btn.classList.remove('is-loading');
        btn.classList.add('is-error');
        textEl.textContent = data.description || 'Hata';

        setTimeout(() => {
          btn.classList.remove('is-error');
          textEl.textContent = original;
          btn.disabled       = false;
        }, 2500);
        return false;
      }
    } catch {
      btn.classList.remove('is-loading');
      btn.classList.add('is-error');
      textEl.textContent = 'Hata';

      setTimeout(() => {
        btn.classList.remove('is-error');
        textEl.textContent = original;
        btn.disabled       = false;
      }, 2500);
      return false;
    }
  }

})();